import { createApplicationService } from "./base/applicationServiceBase";
import { AccountsAPI } from "api/axios.config";

//-------------------------------------------
//           API Functions
//-------------------------------------------

const TRANSACTION_PERIOD_BASE = "/TransactionPeriods";

const fetchTransactionPeriodsAPI = () => 
  AccountsAPI.get(`${TRANSACTION_PERIOD_BASE}`);

const updateTransactionPeriodAPI = (id, data) =>
  AccountsAPI.post(`${TRANSACTION_PERIOD_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

//-------------------------------------------
//           Base Service
//-------------------------------------------

const baseService = createApplicationService({
  name: "transactionPeriods",
  apiFetchFn: fetchTransactionPeriodsAPI,
  apiUpdateFn: updateTransactionPeriodAPI,
});

//-------------------------------------------
//           Reducer
//-------------------------------------------

const transactionPeriodReducer = baseService.reducer;

//-------------------------------------------
//           Core Functions
//-------------------------------------------

const getTransactionPeriods = baseService.getData;
const updateTransactionPeriod = baseService.updateData;
const resetTransactionPeriods = baseService.resetData;
const useTransactionPeriods = baseService.useData;

//-------------------------------------------
//           Additional Functions
//-------------------------------------------

const getCurrentTransactionPeriodAPI = () => 
  AccountsAPI.get(`${TRANSACTION_PERIOD_BASE}/Current`);

const getCurrentSessionTransactionPeriodAPI = (sessionPeriod) => 
  AccountsAPI.get(`${TRANSACTION_PERIOD_BASE}/Current?sessionPeriod=${sessionPeriod}`);

const getCurrentPeriod = async () => {
  try {
    const response = await getCurrentTransactionPeriodAPI();
    return response.data.data;
  } catch (error) {
    console.error("Error fetching current period:", error);
    return null;
  }
};

const getSessionPeriod = async (sessionPeriod) => {
  try {
    const response = await getCurrentSessionTransactionPeriodAPI(sessionPeriod);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching session period:", error);
    return null;
  }
};

const initializeTransactionPeriods = async () => {
  try {
    await getTransactionPeriods();
  } catch (error) {
    console.error("Error initializing transaction periods:", error);
  }
};

//-------------------------------------------
//           Exports
//-------------------------------------------

export {
  transactionPeriodReducer,
  getTransactionPeriods,
  updateTransactionPeriod,
  resetTransactionPeriods,
  useTransactionPeriods,
  getCurrentPeriod,
  getSessionPeriod,
  initializeTransactionPeriods,
};
